<template functional>
    <div class="helper">
        <img src="/images/icon.questionmark.svg" />
        <p>{{ props.text }}</p>
    </div>
</template>

<script>
    export default {
        name: "HelperBox",
        props: {
            text: {
                type: String,
                required: true
            }
        }
    }
</script>